import { combineReducers } from 'redux';

import { reducer as deviceStatusesReducer } from './deviceStatuses';
import { reducer as proximitySettingsReducer } from './proximitySettings';
import { reducer as trackingSettingsReducer } from './trackingSettings';
import { reducer as versionStatusesReducer } from './versionStatuses';

export { loadTrackingSettings, saveTrackingSettings, resetTrackingSettings } from './trackingSettings';
export { loadProximitySettings, saveProximitySettings, resetProximitySettings } from './proximitySettings';
export {
  loadVersionStatuses,
  currentApplicationBuildNumberSelector,
  appVersionsSelector,
  resetVersionStatuses,
} from './versionStatuses';
export {
  exportDeviceStatuses,
  deviceStatusesSelector,
  deviceStatusCountSelector,
  resetDeviceStatuses,
} from './deviceStatuses';

export const reducer = combineReducers({
  deviceStatuses: deviceStatusesReducer,
  proximitySettings: proximitySettingsReducer,
  trackingSettings: trackingSettingsReducer,
  versionStatuses: versionStatusesReducer,
});
